module.exports = __webpack_public_path__ + "img/d5.f5c9bc3d.png";